<template src='./calendarView.pug' lang='pug'></template>

<script>
import language from '../../../build/language/index'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import vSelect from 'vue-select'

export default {
  name: 'CalendarView',

  components: {
    Datepicker,
    vSelect
  },

  computed: {
    monthPickerLanguage () {
      return this.language.getDatePickerLanguageObject()
    },
    alertMessage () {
      return this.$t('calendarioConciliacao.alerta.disclaimer')
    },
    orderedStatusList () {
      return this.situationList.sort((a, b) => a.prioridade - b.prioridade)
    }
  },

  props: {
    monthToShow: {
      type: Date,
      required: true
    },
    setStartDate: {
      type: Function,
      required: true,
      default: () => null
    },
    setEndDate: {
      type: Function,
      required: true,
      default: () => null
    },
    setMonth: {
      type: Function,
      required: true,
      default: () => null
    },
    conciliacaoData: {
      type: Array,
      required: true,
      default: []
    },
    categories: {
      type: Array,
      required: true,
      default: []
    },
    isLoadingData: {
      type: Boolean,
      required: true
    },
    setCategory: {
      type: Function,
      required: true,
      default: () => null
    },
    selectedCategory: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      language: language,
      monthPick: null,
      calendarData: {
        weeks: []
      },
      situationList: [
        {
          id: 'A',
          nome: this.$t('statusConciliacao.aberto'),
          color: '#FFD54F',
          prioridade: 1
        },
        {
          id: 'C',
          nome: this.$t('statusConciliacao.conciliado'),
          color: '#81C784',
          prioridade: 3
        },
        {
          id: 'M',
          nome: this.$t('calendarioConciliacao.detalhe.conciliadoManualmente'),
          color: '#4DB6AC',
          prioridade: 4
        },
        {
          id: 'D',
          nome: this.$t('statusConciliacao.divergente'),
          color: '#E57373',
          prioridade: 2
        }
      ],
      fromDate: null,
      toDate: null,
      hasFirstClick: false,
      filteredStatus: {
        id: 'A',
        nome: this.$t('statusConciliacao.aberto'),
        color: '#FFD54F',
        prioridade: 1
      },
      filteredCategory: {
      },
      isUpdatingInfo: false
    }
  },

  watch: {
    monthPick: {
      handler (newVal, oldVal) {
        if (newVal &&
          !moment.utc(newVal).startOf('day').isSame(moment.utc(this.monthToShow).startOf('day'))
        ) {
          this.setMonth(newVal)
        } else {
          this.monthPick = this.monthToShow
        }
      },
      deep: true
    },
    conciliacaoData: {
      handler () {
        this.generateCalendar()
      },
      deep: true
    },
    categories: {
      handler () {
        if (this.categories && this.categories.length > 0) {
          this.filteredCategory = this.categories[0]
        }
      },
      deep: true
    },
    selectedCategory: {
      handler () {
        this.filteredCategory = this.selectedCategory
      },
      deep: true
    },
    filteredCategory: {
      handler () {
        this.isUpdatingInfo = true
        this.mountCalendarInfo()
        this.isUpdatingInfo = false
        this.setCategory(this.filteredCategory)
      },
      deep: true
    }
  },

  methods: {
    getReferenceFromDay (day) {
      return moment.utc(day).valueOf()
    },
    /*
      Normaliza matriz de dias do mês, organizando o arranjo posicionalmente
    */
    generateCalendar () {
      let weeksToShow = this.calculateWeeks()
      weeksToShow.map(wk => {
        if (wk.length < 7) {
          let miss = 7 - wk.length
          // completa semana com 7 posicoes
          for (let i = 0; i < miss; i++) {
            wk.splice(i, 0, {})
          }
          // reorganiza as posicoes com cada dia no seu devido index (dom = 0, seg = 1...)
          wk.map((day, dayIndex) => {
            let weekIndex = day.date ? moment.utc(day.date).day() : -1
            if (weekIndex >= 0) {
              wk.splice(dayIndex, 1)
              wk.splice(weekIndex, 0, day)
            }
          })
        }
        wk.map(day => {
          // marca a data atual como pre selecionada
          day.selected = this.isToday(day.date)
        })
      })
      this.calendarData.weeks = weeksToShow
      this.mountCalendarInfo()
    },
    /*
      Gera matriz de dias separados por semana
    */
    calculateWeeks () {
      let startDate = moment.utc(this.monthToShow).startOf('month')
      let endDate = moment.utc(startDate).endOf('month')
      let month = moment.utc(this.monthToShow).get('month')
      let weeks = []
      let perWeek = []
      let difference = endDate.diff(startDate, 'days')
      perWeek.push({date: startDate.toDate()})
      let index = 0
      let lastWeek = false
      while (startDate.add(1, 'days').diff(endDate) < 0) {
        if (startDate.day() !== 0) {
          perWeek.push({date: startDate.toDate()})
        } else {
          if ((startDate.clone().add(7, 'days').month() === month)) {
            weeks.push(perWeek)
            perWeek = []
            perWeek.push({date: startDate.toDate()})
          } else if (Math.abs(index - difference) > 0) {
            if (!lastWeek) {
              weeks.push(perWeek)
              perWeek = []
            }
            lastWeek = true
            perWeek.push({date: startDate.toDate()})
          }
        }
        index += 1
        if (
          (lastWeek === true && Math.abs(index - difference) === 0) ||
          (Math.abs(index - difference) === 0 && perWeek.length === 1)
        ) {
          weeks.push(perWeek)
        }
      }
      return weeks
    },
    formatDateGetDay (day) {
      return day ? moment.utc(day).format('DD') : ''
    },
    isToday (date) {
      return date ? moment.utc(date).endOf('day').isSame(moment.utc().endOf('day')) : false
    },
    handleClickDay (selectedDate) {
      if (selectedDate) {
        if (this.hasFirstClick) {
          let firstDate = moment.utc(this.fromDate).startOf('day').isBefore(moment.utc(selectedDate).startOf('day')) ? this.fromDate : selectedDate
          let lastDate = moment.utc(this.fromDate).startOf('day').isAfter(moment.utc(selectedDate).startOf('day')) ? this.fromDate : selectedDate
          this.setStartDate(firstDate)
          this.setEndDate(lastDate)
          this.hasFirstClick = false
        } else {
          this.calendarData.weeks.map(week => {
            week.map(day => {
              day.selected = day.date ? moment.utc(day.date).endOf('day').isSame(moment.utc(selectedDate).endOf('day')) : false
            })
          })
          this.hasFirstClick = true
          this.fromDate = selectedDate
        }
      }
    },
    unselectAll () {
      this.calendarData.weeks.map(week => {
        week.map(day => {
          day.selected = false
        })
      })
    },
    getConciliationLabel (status) {
      let label = ' - '
      this.situationList.map(item => {
        if (item.id === status) {
          label = item.nome
        }
      })
      return label
    },
    getColorByStatus (status) {
      let label = '#64b5f6'
      this.situationList.map(item => {
        if (item.id === status) {
          label = item.color
        }
      })
      return label
    },
    formatPercent (value) {
      if (!isNaN(value)) {
        let result = Number(value)
        return (result % 1 !== 0 ? result.toFixed(2) : result) + '%'
      }
      return value
    },
    mountCalendarInfo () {
      if (this.conciliacaoData && this.conciliacaoData.length > 0) {
        this.calendarData.weeks.map(week => {
          week.map(day => {
            let baseDataByDay = this.conciliacaoData.filter((item) => {
              return item.situacao !== 'N' &&
                    (this.filteredCategory && this.filteredCategory.id !== '-1' ? this.filteredCategory.nome === item.categoria : true) &&
                    moment.utc(item.dataMin).startOf('day').isSame(moment.utc(day.date).startOf('day'))
            })
            let summaryByStatus = []
            let totalByDay = 0
            baseDataByDay.map(item => {
              totalByDay += (item.totalExtrato + item.totalMovFinan)
            })
            baseDataByDay.map(item => {
              let summaryIndex = summaryByStatus.findIndex(el => el.status === item.situacao)
              if (summaryIndex >= 0) {
                let summary = summaryByStatus.at(summaryIndex)
                summary.totalByStatus += (item.totalExtrato + item.totalMovFinan)
                summaryByStatus.splice(summaryIndex, 1, summary)
              } else {
                let summary = {
                  status: item.situacao,
                  totalByStatus: (item.totalExtrato + item.totalMovFinan)
                }
                summaryByStatus.push(summary)
              }
            })
            summaryByStatus.map(sum => {
              sum.percent = totalByDay !== 0
                ? (100 * sum.totalByStatus) / totalByDay
                : 'N/A'
            })
            day.summary = summaryByStatus
          })
        })
        this.$forceUpdate()
      }
    },
    handleMouseOver (date, isOverElement) {
      if (date && this.hasFirstClick) {
        if (isOverElement) {
          let firstDate = moment.utc(this.fromDate).startOf('day').isBefore(moment.utc(date).startOf('day')) ? this.fromDate : date
          let lastDate = moment.utc(this.fromDate).startOf('day').isAfter(moment.utc(date).startOf('day')) ? this.fromDate : date
          this.calendarData.weeks.map(week => {
            week.map(day => {
              day.selected = day.date
                            ? moment.utc(day.date).isBetween(moment.utc(firstDate).startOf('day'), moment.utc(lastDate).endOf('day'), undefined, '[]')
                            : false
            })
          })
        }
      }
    },
    setFilteredStatus (status) {
      this.filteredStatus = status
    }
  },
  mounted () {
    this.monthPick = this.monthToShow
  }
}
</script>
<style>
.week-header {
  display: flex !important;
  -webkit-user-select: none !important;
  -ms-user-select: none !important;
  user-select: none !important;
}
.week-column-day-header {
  flex: 1 0 20px;
  border-right: 1px solid #e0e0e0;
  color: #757575;
  padding: 4px;
  padding-bottom: 0;
}
.week-day {
  flex: 1 !important;
  width: 0 !important;
  border-right: 1px solid #e0e0e0 !important;
  border-bottom: 1px solid #e0e0e0 !important;
  padding: 4px !important;
  overflow: hidden !important;
}
.label-today {
  color: #0068AB;
  font-weight: bolder;
  font-size: large;
}
.selected-day {
  background: #0068AB15;
  border: 1px solid #0068AB !important;
}
.label-indicador-percent {
  font-size: 15px;
  font-weight: bold;
}
.label-indicador-status {
  font-family: 'Inter', sans-serif;
  text-transform: initial !important;
  color: #515151;
  font-weight: normal !important;
  font-size: 12px !important;
}
.alert-calendar {
  font-style: italic;
  font-size: 12px;
  color: #666;
  padding-top: 10px;
}
.detail-line-position {
  text-align: end;
  padding-left: 1vh;
  padding-right: 1vh;
}
.square-5 {
  width: 1.5vh;
  height: 1.5vh;
  margin-right: 0.5vh;
}
.filter-active {
  opacity: 100%;
}
.filter-inactive {
  opacity: 55%;
}
.filter-item {
  cursor: pointer;
  height: 4vh;
  align-items: center;
}
.filter-item:hover {
  opacity: 100%;
  border: 2px solid;
  border-color: #3BB5B4;
  border-radius: 10px;
}
.vdp-datepicker {
  border-radius: 5px;
  border: 1px solid #ccc;
  padding: 7px 8px 7px 8px;
  margin-right: 5px;
}
.margin-box-filter {
  margin: 5px 5px 20px 0px;
}
.calendar-month-picker {
  border: none;
  height: 3.2vh;
  width: 18vh;
}
</style>



// WEBPACK FOOTER //
// CalendarView.vue?63f939c4